import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-column",
  "use": "icon-column-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-column\"><path d=\"M12 2H4c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M4 13c-.6 0-1-.4-1-1V6h2.5v7zm2.5-7h3v7h-3zm6.5 6c0 .6-.4 1-1 1h-1.5V6H13zm0-7H3V4c0-.6.4-1 1-1h8c.6 0 1 .4 1 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol